/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import { Grid, Row, Col, Media,  ControlLabel, FormControl, FormGroup, Label } from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import NotificationSystem from 'react-notification-system';
import {style} from "../../../variables/Variables";
import Button from "components/CustomButton/CustomButton.jsx";
import { importOrder ,getCity} from "../../../Listfunction";
import axios from 'axios';

class adduser extends Component {
  constructor(props) {
    super(props)
    this.state = {
    email: "",
    password: "",
    cfpassword: "",
    process : false,
    errors : [],
    useraccess : '',
    errormessage : '',
    btnDisabled:true,
    btnText : "Submit",
    profile_data : '',
    processing : true,
    errormessages : [],
    profile : '',
    message: '',
    selectedFile:[],
    country_detail:[],
    city_info:[]
  }
  this.onSubmit = this.onSubmit.bind(this);
  this.onChange = this.onChange.bind(this);
  this.componentDidMount = this.componentDidMount.bind(this)
  this.handleFileChange = this.handleFileChange.bind(this)
  this.onDownload = this.onDownload.bind(this);
  
}
onDownload = (e) =>{
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
    const link = document.createElement("a");
        link.href = "https://admin-api-staging.flash.health/uploads/demo_order.xlsx"
        link.target = "_blank";
        // document.body.appendChild(link)
        link.click();
}
handleInputChange = (e, index) => {
  const { name, value } = e.target;
  // const {value } = e.target.type === 'select' ? e.target.selected : e.target.value;
  // console.log(list[index]['country'])

  if (value != "0") {
    
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    
    var country_id = value;
    getCity(obj, country_id).then((res) => {
      
      this.setState({ city_info: res.data });
    });
  } else if (value == "0") {
    this.setState({ city_info: [] });
  }
  this.setState({
    [name]: value
  });
};
componentDidMount()
{
    this.setState({_notificationSystem: this.refs.notificationSystem})
    setTimeout(
      function() {
        this.setState({ cardHidden: false }); 
      }.bind(this),
      700
    );
    var token = JSON.parse(localStorage.getItem('user'));  
    if(token.role != 1 && token.role != 2)
    {
      this.props.history.push("/dashboard");
    }
        console.log(token,'user');  
        this.setState({
          useraccess : token.role
        })
      const  obj = token.token
    
}

  onChange = (event) =>{
    const target = event.target;
    const value = target.type === 'select' ? target.selected : target.value;
    const name = target.name;
      this.setState({
        [name]: value
      });
  }
  handleSuccess(position){
    var color = Math.floor((Math.random() * 4) + 1);
    var level;
    switch (color) {
        case 1:
        level = 'success';
        break;
        case 2:
        level = 'warning';
        break;
        case 3:
        level = 'error';
        break;
        case 4:
        level = 'info';
        break;
        default:
        break;
    }
    level = 'success';
    this.state._notificationSystem.addNotification({
        title: (<span data-notify="icon" className="pe-7s-gift"></span>),
        message: (
            <div>
                 <b>User</b> - Added Successfully .
            </div>
        ),
        level: level,
        position: position,
        autoDismiss: 15,
    });
  }
  handleClick(position){
    var color = Math.floor((Math.random() * 4) + 1);
    var level;
    switch (color) {
        case 1:
        level = 'success';
        break;
        case 2:
        level = 'warning';
        break;
        case 3:
        level = 'error';
        break;
        case 4:
        level = 'info';
        break;
        default:
        break;
    }
    level = 'error';
    this.state._notificationSystem.addNotification({
        title: (<span data-notify="icon" className="pe-7s-gift"></span>),
        message: (
            <div>
                 <b>something went wrong</b>.
            </div>
        ),
        level: level,
        position: position,
        autoDismiss: 15,
    });
}
  async onSubmit() {
    this.setState({errormessages : []  });
      let error = false;
      this.setState({btnDisabled:true})
      this.setState({btnText:"Processing"})
      if(!error)
      {
        var mobile = this.state.ccode + this.state.mobileno

        var token = JSON.parse(localStorage.getItem('user'));
        const  obj = token.token;
        if(this.state.profile.length != 0 )
        {  
            this.setState({processing:true})

            const fdata = new FormData() 
                fdata.append('csv_file', this.state.profile)
                
        
  //          this.setState({ processing:false }, async() => {

                let url = process.env.REACT_APP_NOT_SECRET_CODE+"/orders/import/excel";
                await axios.post(url, fdata, {headers : {'Authorization' : 'Bearer '+obj,
                 'X-Country-Code' : 'BD',
                 'X-Client-Name' : 'WEBSITE',
                 'X-Client-Version' : '123',
                 'Content-Type':'application/json',
                 'X-Request-Id' : '124',
               }
                 })
                 .then(res => { 
                     console.log(res,"result")
                     if(res.data.success  == false)
                     {
                       this.setState({errors:res.data.data})
                     }
                   this.setState({message:res.data.message})
                   this.setState({btnText:"Submit"});
                   this.setState({ btnDisabled: false });
                 })

            
  
            }
            else{
              alert("Please upload Excel file")
            }
        }
  }
  handleNetworkError(position)
  {
    var color = Math.floor((Math.random() * 4) + 1);
    var level;
    switch (color) {
        case 1:
        level = 'success';
        break;
        case 2:
        level = 'warning';
        break;
        case 3:
        level = 'error';
        break;
        case 4:
        level = 'info';
        break;
        default:
        break;
    }
    level = 'error';
    this.state._notificationSystem.addNotification({
        title: (<span data-notify="icon" className="pe-7s-gift"></span>),
        message: (
            <div>
                 <b>Network Error</b>.
            </div>
        ),
        level: level,
        position: position,
        autoDismiss: 15,
    });
  }

 handleFileChange(event) {
    //console.log(event.target.files[0] ,"file object");  
    this.setState({ profile :event.target.files[0] ,btnDisabled:false });
 }
 
 upload(){
  document.getElementById("selectImage").click()
 }
  
 render() {
    const errormessage = this.state.errormessage;
    const errormessages = this.state.errormessages;
    return (
        <div className="main-content">
        <Grid fluid>
        <NotificationSystem ref="notificationSystem" style={style}/>

          <Row>
            <Col md={6}>
              <Card
                
                content={
                  <form >
                  
              {errormessages.length != 0 && 
                  <div className=' alert alert-danger'> 

                  {errormessages.map((data) => (
                    <React.Fragment>
                    <li>{data}</li>
                    </React.Fragment>
                  ))}
                  </div> }

                    <Row>
                      <Col md={12}>

                     
                   
                    <FormGroup>
                      <ControlLabel>Order Excel</ControlLabel><br></br>
                      <input 
                      style={{display: 'none'}}
                      id='selectImage' 
                      type="file" 
                      className="form-control" 
                      name="profile"  
                      onChange={this.handleFileChange} 
                       />
                         <Button  
                         onClick={this.upload} 
                         style={{ color: "#2B3A41" }} > 
                         {" "} <i className={(this.state.profile == "" )?"fa fa-plus":"fa fa-pencil fa-fw"}></i> {" "}
                          {(this.state.profile == "" )?'Choose Excel':'Change Excel'} 
                         </Button>
                         </FormGroup>
                        
                  <Button class="btn-color" disabled={this.state.btnDisabled} onClick={this.onSubmit.bind(this)}  fill  >
                    {this.state.btnText}
                  </Button>

                  <div>
                    <br/>
                    <br/>
                    {this.state.message != "" && <h6>{this.state.message}</h6>}
                    <br/>
                    
                    {this.state.errors.length != 0 &&
                    <React.Fragment>
                        <h5>Errors</h5>
                        <ul>
                          {this.state.errors.map(index =>{
                            return <li>{index}</li>
                          })}
                        </ul>
                    </React.Fragment>
                  }
                  </div>
                  <div>
                    <br/>
                    <Button class="btn-color"  onClick={this.onDownload.bind(this)}  fill  >
                      Download Sample Excel
                    </Button>
                  </div>
                  </Col>
                      </Row>
                
                
                </form>
                }
              />
            
          </Col>
        </Row>
      </Grid>
      </div>
    );
  }
}

export default adduser;
